__turbopack_context__.v({
  "dismissBtn": "QCBV0a_dismissBtn",
  "inner": "QCBV0a_inner",
  "shell": "QCBV0a_shell",
});
